export const CLOUDFLARE_TURNSTILE_ENABLED = 'cloudflareTurnstileEnabled';
export const SHOW_FEATURE_FLAG_CONSOLE = 'showFeatureFlagConsole';
export const SHOW_MAINTENANCE_BANNER = 'showMaintenanceBanner';
export const ENABLE_INTERNAL_SKIP_FUNNEL = 'enableInternalSkipFunnel';
export const ENABLE_USABILLA = 'enableUsabilla';
export const CAN_TRACK = 'canTrack';
export const ALLOW_THANK_YOU_PAGE_DEVELOPMENT_WITHOUT_REDIRECTS =
  'allowThankYouPageDevelopmentWithoutRedirects';
export const ENABLE_TWO_FACTOR_AUTH = 'enableTwoFactorAuth';
export const POST_SKIP_MODAL = 'postSkipModal';
export const LOGIN_SMS = 'loginSMS';
export const SPICE_PREFERENCES = 'spicePreferences';
export const ORDER_AGAIN = 'orderAgain';
export const ORDER_AGAIN_FILTER_FLAG = 'orderAgainFilter';
export const SUGGESTED_PAIRINGS_SLIDEOUT = 'suggestedPairingsSlideout';
